/**
 * @generated SignedSource<<208dbcc9ae1d9866dcca034afd8f322e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_view$data = {
  readonly " $fragmentSpreads": FragmentRefs<"experienceRegistry_issueNavigator_SidebarExperienceRegistry_view">;
  readonly " $fragmentType": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_view";
};
export type experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_view$key = {
  readonly " $data"?: experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_view">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isSavedViewConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_view",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isSavedViewConditionalFormattingEnabled",
          "variableName": "isSavedViewConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_view"
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
};

(node as any).hash = "7179917945065d6e68ed8645bd82cdcd";

export default node;
